import { ScribeCorrectionModeUnset } from '../types/config';
const initialState = {
    delay: 1500,
    fontSize: 20,
    correctionMode: window.localStorage.getItem('scribe_correction_mode') || ScribeCorrectionModeUnset,
    mutationTriggers: [],
    searchModeEnabled: false,
    searchQuery: '',
    transcriptFinalizeWait: 9000,
    wordBeingEdited: false,
    fullScreen: window.location.href.includes('fii.ava.me/session-'),
    bottomMenu: false,
    metaDown: 0,
    displayShortcuts: false,
    insertSpeakerNameMode: false,
    updateAudioSourceMode: false,
    electronCaptionMode: false,
};
export default function scribeTranscriptUI(state = initialState, action) {
    switch (action.type) {
        case 'RECEIVED_SCRIBE_CONVERSATION_TRANSCRIPT_MUTATION': {
            if (!action.trigger)
                return state;
            const { mutation, transcriptId, trigger: { src }, } = action;
            return Object.assign(Object.assign({}, state), { mutationTriggers: [
                    // ...state.mutationTriggers,
                    {
                        transcriptId,
                        mutationId: mutation.id,
                        src,
                    },
                ] });
        }
        case 'SCRIBE_ENTER_SEARCH_MODE':
            return Object.assign(Object.assign({}, state), { searchModeEnabled: true });
        case 'ENTER_UPDATE_AUDIO_SOURCE_MODE':
            return Object.assign(Object.assign({}, state), { updateAudioSourceMode: true });
        case 'EXIT_UPDATE_AUDIO_SOURCE_MODE':
            return Object.assign(Object.assign({}, state), { updateAudioSourceMode: false });
        case 'SCRIBE_EXIT_SEARCH_MODE':
            return Object.assign(Object.assign({}, state), { searchModeEnabled: false, searchQuery: '' });
        case 'SCRIBE_UPDATE_SEARCH_QUERY':
            return Object.assign(Object.assign({}, state), { searchQuery: action.query });
        case 'SCRIBE_SET_FONT_SIZE':
            return Object.assign(Object.assign({}, state), { fontSize: action.fontSize });
        case 'SCRIBE_SET_CORRECTION_MODE':
            window.localStorage.setItem('scribe_correction_mode', action.correctionMode);
            return Object.assign(Object.assign({}, state), { correctionMode: action.correctionMode });
        case 'SCRIBE_TRANSCRIPT_FINALIZE_WAIT':
            return Object.assign(Object.assign({}, state), { transcriptFinalizeWait: action.transcriptFinalizeWait });
        case 'SCRIBE_WORD_EDIT_STARTED':
            return Object.assign(Object.assign({}, state), { wordBeingEdited: true });
        case 'SCRIBE_WORD_EDIT_STOPED':
            return Object.assign(Object.assign({}, state), { wordBeingEdited: false });
        case 'CLEAN_APP':
            return Object.assign({}, initialState);
        case 'FULL_SCREEN':
            return Object.assign(Object.assign({}, state), { fullScreen: action.value });
        case 'ELECTRON_CAPTION_MODE':
            return Object.assign(Object.assign({}, state), { electronCaptionMode: action.value });
        case 'META_DOWN':
            return Object.assign(Object.assign({}, state), { metaDown: action.id });
        case 'META_UP':
            return Object.assign(Object.assign({}, state), { metaDown: 0, displayShortcuts: state.insertSpeakerNameMode });
        case 'DISPLAY_SHORTCUTS':
            return Object.assign(Object.assign({}, state), { displayShortcuts: true });
        case 'ENTER_INSERT_SPEAKER_NAME_MODE':
            return Object.assign(Object.assign({}, state), { displayShortcuts: true, insertSpeakerNameMode: true });
        case 'EXIT_INSERT_SPEAKER_NAME_MODE':
            return Object.assign(Object.assign({}, state), { displayShortcuts: false, insertSpeakerNameMode: false });
        case 'SCRIBE_TRANSCRIPT_SELECT_WORD':
            return Object.assign(Object.assign({}, state), { wordBeingEdited: false });
        case 'SCRIBE_TRANSCRIPT_DESELECT_WORD':
            return Object.assign(Object.assign({}, state), { wordBeingEdited: false });
        default:
            // eslint-disable-next-line no-unused-expressions
            action;
            return state;
    }
}
